import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/faqs/view/faqs-view.js");
